// extracted by mini-css-extract-plugin
export default {"widgetSection":"TeamRightWidgetSpace_widgetSection__Q4l9c"};